import { render } from "./BaseTitle.vue?vue&type=template&id=1ff8b0d6&scoped=true"
import script from "./BaseTitle.vue?vue&type=script&lang=js"
export * from "./BaseTitle.vue?vue&type=script&lang=js"

import "./BaseTitle.vue?vue&type=style&index=0&id=1ff8b0d6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff8b0d6"]])

export default __exports__